import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import { useDebugValue } from "react";
import usePersist from "./usePersist";
import useSafeState from "./useSafeState";
function useToggle() {
  var initialValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var _useSafeState = useSafeState(!!initialValue),
    _useSafeState2 = _slicedToArray(_useSafeState, 2),
    value = _useSafeState2[0],
    setValue = _useSafeState2[1];
  var toggle = usePersist(function (newValue) {
    if (newValue !== undefined) {
      setValue(!!newValue);
    } else {
      setValue(function (value) {
        return !value;
      });
    }
  });
  var toggleOn = usePersist(function () {
    setValue(true);
  });
  var toggleOff = usePersist(function () {
    setValue(false);
  });
  useDebugValue(value);
  return [value, {
    toggle: toggle,
    toggleOn: toggleOn,
    toggleOff: toggleOff
  }];
}
export default useToggle;